export default __webpack_public_path__ + "static/media/CheckYourFridge.8fd4c0e6.gif";